<template>
  <v-card flat class="pa-4">
    <v-switch label="Forecast by customer" dense v-model="preferences.byCustomer"/>
    <v-select label="Product units" :items="['Bottles','Cases','Pallets','LAA','Litres']" outlined dense hide-details v-model="preferences.productUnits"/>
  </v-card>
</template>

<script>
export default {
  name: 'PlanningForecastingPreferences',
  data() {
    return {
      preferences: {}
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    }
  },
  watch: {
    preferences: {
      async handler() {
        const results = await this.$apiCall(`mutation PlanningForecastingPreferences($input:ForecastPreferencesInput!) {
                                              forecastSetPreferences(input:$input) {
                                                byCustomer,productUnits
                                              }
                                            }`,
                                            {input:this.preferences});
        if (!results.error)
          this.$emit('update', results.data.forecastSetPreferences)
      },
      immediate: false,
      deep: true
    }
  },
  async created() {
    const results = await this.$apiCall(`query PlanningForecastingPreferences {
                                          forecastPreferences {
                                            byCustomer,productUnits
                                          }
                                        }`,
                                        {});
    if (!results.error)
      this.preferences = results.data.forecastPreferences;
  }
}
</script>